import { render, staticRenderFns } from "./FilterItemPosition.vue?vue&type=template&id=8323ef22&functional=true&"
var script = {}
import style0 from "./FilterItemPosition.vue?vue&type=style&index=0&id=8323ef22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports